export default __webpack_public_path__ + "static/media/logo-vertical-white.692d9369.svg";